import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    getScannerListdata,
    getUpdateScannerOrderdata,
    getActivecategoryplans,
} from '../../../Services/Admin/Admin';
import Table from '../../../Extracomponents/Table';
import { SquarePen } from 'lucide-react';
import { Tooltip } from 'antd';
import { fDateTimeH } from '../../../../Utils/Date_formate';
import Loader from '../../../../Utils/Loader';
import showCustomAlert from '../../../Extracomponents/CustomAlert/CustomAlert';
import ReusableModal from '../../../components/Models/ReusableModal';
import Select from 'react-select';


const Scannerlist = () => {


    const [clients, setClients] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [model, setModel] = useState(false);
    const [plan, setPlan] = useState([])

    const [updatetitle, setUpdatetitle] = useState({
        client_id: "",
        id: "",
        plan_id: [],
        price: "",
        countadd: "",
    });

    useEffect(() => {
        getScannerdata();
        getcategoryplanlist();
    }, []);




    const getcategoryplanlist = async () => {
        try {
            const response = await getActivecategoryplans();
            if (response.status) {
                setPlan(response.data);
            }
        } catch (error) {
            console.log("error");
        }
    }



    const getScannerdata = async () => {
        try {
            const response = await getScannerListdata();
            if (response.status) {
                setClients(response.data);
            }
        } catch (error) {
            console.log("Error fetching scanner data:", error);
        }
        setIsLoading(false);
    };




    const updateScanner = async () => {
        const { price, countadd } = updatetitle;

        if (!price) {
            showCustomAlert("error", "Please fill the Price fields.");
            return;
        }
        if (!countadd) {
            showCustomAlert("error", "Please fill the Count  fields.");
            return;
        }
        try {

            const data = {
                id: updatetitle.id,
                plan_id: updatetitle.plan_id,
                price: updatetitle.price,
                countadd: updatetitle.countadd,
            };

            const response = await getUpdateScannerOrderdata(data);

            if (response && response.status) {
                showCustomAlert("Success", response.message);
                setModel(false);
                getScannerdata();
            } else {
                showCustomAlert("error", response.message || "Update failed");
            }
        } catch (error) {
            showCustomAlert("error", "Server error");
        }
    };


    const filteredClients = clients.filter((item) => {
        const planTitles = item.plan_info?.map(p => p.title).join(", ").toLowerCase();
        const price = item.price?.toString().toLowerCase();
        const count = item.countadd?.toString().toLowerCase();
        const search = searchInput.toLowerCase();

        return (
            planTitles?.includes(search) ||
            price?.includes(search) ||
            count?.includes(search)
        );
    });




    const updateServiceTitle = (updatedField) => {
        setUpdatetitle((prev) => ({
            ...prev,
            ...updatedField,
        }));
    };

    const columns = [

        {
            name: 'Name',
            selector: row => row?.plan_info?.map(item => item.title).join(', '),
            sortable: true,
            // width: '200px',
        },
        {
            name: 'Price',
            selector: row => row?.price,
            sortable: true,
            // width: '150px',
        },
        {
            name: 'Count',
            selector: row => row?.countadd,
            sortable: true,
            // width: '200px',
        },
        {
            name: 'CreatedAt',
            selector: row => fDateTimeH(row?.createdAt),
            sortable: true,
            // width: '270px',
        },
        {
            name: "Actions",
            cell: (row) => (
                <Tooltip title="Update">
                    <SquarePen
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            setModel(true);
                            setUpdatetitle({
                                client_id: row.client_id || "",
                                id: row._id || "",
                                plan_id: row.plan_id || "",
                                price: row.price || "",
                                countadd: row.countadd || "",
                            });
                        }}
                    />
                </Tooltip>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    return (
        <div className="page-content">
            <div className="page-breadcrumb d-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Scanner List</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">
                            <li className="breadcrumb-item">
                                <Link to="/admin/dashboard">
                                    <i className="bx bx-home-alt" />
                                </Link>
                            </li>
                        </ol>
                    </nav>
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className="d-sm-flex align-items-center mb-4 gap-3 justify-content-between">
                        <div className="position-relative">
                            <input
                                type="text"
                                className="form-control ps-5 radius-10"
                                placeholder="Search ..."
                                onChange={(e) => setSearchInput(e.target.value)}
                                value={searchInput}
                            />
                            <span className="position-absolute top-50 product-show translate-middle-y">
                                <i className="bx bx-search" />
                            </span>
                        </div>
                    </div>
                    {isLoading ? (
                        <Loader />
                    ) : clients.length > 0 ? (
                        <div className="table-responsive">
                            <Table columns={columns} data={filteredClients} />
                        </div>
                    ) : (
                        <div className="text-center mt-5">
                            <img src="/assets/images/nodata.png" alt="No Records Found" className="w-25" />
                        </div>
                    )}
                </div>
            </div>

            <ReusableModal
                show={model}
                onClose={() => setModel(false)}
                title={<>Update Scanner</>}
                body={
                    <>

                        <div className="col-md-12">
                            <label>Price</label>
                            <input
                                className="form-control mb-2"
                                type="number"
                                value={updatetitle.price}
                                onChange={(e) => updateServiceTitle({ price: e.target.value })}
                            />
                        </div>
                        <div className="col-md-12">
                            <label>Count Add</label>
                            <input
                                className="form-control mb-2"
                                type="number"
                                value={updatetitle.countadd}
                                onChange={(e) => updateServiceTitle({ countadd: e.target.value })}
                            />
                        </div>
                        <div className="col-md-12">
                            <label>Plan</label>
                            <Select
                                isMulti
                               classNamePrefix={"my-select"}
                                className="mb-2"
                                options={plan?.map((item) => ({
                                    label: `${item.title} (${item.servicesDetails?.map(service => service.title).join(', ')})`,
                                    value: item._id,
                                }))}
                                value={
                                    plan
                                        ?.filter((item) => updatetitle.plan_id?.includes(item._id))
                                        .map((item) => ({
                                            label: `${item.title} (${item.servicesDetails?.map(service => service.title).join(', ')})`,
                                            value: item._id,
                                        }))
                                }
                                onChange={(selectedOptions) =>
                                    updateServiceTitle({ plan_id: selectedOptions.map(option => option.value) })
                                }
                            />
                        </div>


                    </>
                }
                footer={
                    <>
                        <button type="button" className="btn btn-primary" onClick={updateScanner}>
                            Save
                        </button>
                        <button
                            className="btn btn-light"
                            onClick={() => setModel(false)}
                        >
                            Cancel
                        </button>
                    </>
                }
            />
        </div>
    );
};

export default Scannerlist;
